import type { FaireProductEntity } from "../../entity_types/product";

export const p_1rayn3ersx: FaireProductEntity = {
  token: "p_1rayn3ersx",
  type: "product",
  name: "Herbal Perineal Spray",
  brandToken: "b_1q5xt82q",
  brandName: "Earth Mama Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/018b8bffef96de9e064e957e73e059e51c0a268c1c182618151252392bd05032.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5070f4c5366cdb892a44c90639e9c7dc4851e0d28af7c63dbb4a61dc4eeee929.jpeg",
    "https://cdn.faire.com/fastly/050a4e036e05caf7ee3a1390f9dbd32e6f1215250a3128516e1cdf4adc2bb189.jpeg",
    "https://cdn.faire.com/fastly/f684da2c22a974cf0f4adb3e604f292ff2b34e204441a256b19a0d439078c41c.jpeg",
    "https://cdn.faire.com/fastly/3bfc44e09579a3da30b377a1a2f806a983fe41e6ed77e557c891582c660d6cde.jpeg",
  ],
  priceDollars: 10.66,
  description:
    "Experiencing a little lightning and thunder down under? Cool things off with Earth Mama’s Herbal Perineal Spray, a soothing, touch-free herbal mist providing temporary “down there” relief with the original upside-down sprayer for easy application. No handstands required.\n\nThis postpartum spray features a refreshing combination of organic witch hazel, cooling cucumber and organic essential oils that help soothe uncomfortable nether regions for anyone who needs it at any time in their life, including during pregnancy and postpartum.\n\nPack this postpartum spray in your birth bag and take it with your peri bottle for those first post childbirth bathroom trips. Or just keep it handy in the bathroom for anyone’s nether region discomfort.\n\nMist as often as needed, especially after bath or toilet use. Store in the refrigerator for extra cooling.\n\nBONUS: Use for a little date night freshen up. Just spray, wipe, and go forth, you saucy minx.\n\n * Formulated specifically for pregnant and postpartum women, but safe and effective For Everyone and Their Mother®. \n * No parabens, propellants, benzocaine or artificial fragrance. \n * Vegan, Leaping Bunny Certified and Plastic Neutral. \n * For external use only. \n * Use with Organic Perineal Balm and Herbal Sitz Bath for the ultimate Take Care Down There® trifecta of soothing relief. \n\n\n\n\n\n\n",
  tags: [],
  msrpDollars: 19.32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:25.027Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
